import React from 'react'

import { Icon } from '../../UI'
import LightTooltip from '../../UI/LightTooltip'

const MultiTalent = ({ tooltip = 'Text', className = '' }) => {
  return (
    <div className={`flex items-center py-[6px] px-[8px] bg-[#338AF3] rounded-[8px] ${className}`}>
      <Icon name="star-medal" className="w-[20px] h-[20px]" />

      <span className="mx-[4px] text-sm font-bold text-[#FDFDFD]">Multitalent</span>

      <LightTooltip
        title={<span className="inline-block w-full text-center">{tooltip}</span>}
        arrow
      >
        <div>
          <Icon name="info" color="#FDFDFD" className="w-[20px] h-[20px]" />
        </div>
      </LightTooltip>
    </div>
  )
}

export default MultiTalent
